import type { ReactElement } from 'react';
import './LoaderVariant4.css';

export function LoaderVariant4(): ReactElement {
  return <div className="lv4" />;
}
